const audioBookFolders = {
  創: '01-Genesis',
  出: '02-Exodus',
  利: '03-Leviticus',
  民: '04-Numbers',
  申: '05-Deuteronomy',
  書: '06-Joshua',
  士: '07-Judges',
  得: '08-Ruth',
  撒上: '09-1Samuel',
  撒下: '10-2Samuel',
  王上: '11-1Kings',
  王下: '12-2Kings',
  代上: '13-1Chronicles',
  代下: '14-2Chronicles',
  拉: '15-Ezra',
  尼: '16-Nehemiah',
  斯: '17-Esther',
  伯: '18-Job',
  詩: '19-Psalms',
  箴: '20-Proverbs',
  傳: '21-Ecclesiastes',
  歌: '22-SongOfSongs',
  賽: '23-Isaiah',
  耶: '24-Jeremiah',
  哀: '25-Lamentations',
  結: '26-Ezekiel',
  但: '27-Daniel',
  何: '28-Hosea',
  珥: '29-Joel',
  摩: '30-Amos',
  俄: '31-Obadiah',
  拿: '32-Jonah',
  彌: '33-Micah',
  鴻: '34-Nahum',
  哈: '35-Habakkuk',
  番: '36-Zephaniah',
  該: '37-Haggai',
  亞: '38-Zechariah',
  瑪: '39-Malachi',
  太: '40-Matthew',
  可: '41-Mark',
  路: '42-Luke',
  約: '43-John',
  徒: '44-Acts',
  羅: '45-Romans',
  林前: '46-1Corinthians',
  林後: '47-2Corinthians',
  加: '48-Galatians',
  弗: '49-Ephesians',
  腓: '50-Philippians',
  西: '51-Colossians',
  帖前: '52-1Thessalonians',
  帖後: '53-2Thessalonians',
  提前: '54-1Timothy',
  提後: '55-2Timothy',
  多: '56-Titus',
  門: '57-Philemon',
  來: '58-Hebrews',
  雅: '59-James',
  彼前: '60-1Peter',
  彼後: '61-2Peter',
  約一: '62-1John',
  約二: '63-2John',
  約三: '64-3John',
  猶: '65-Jude',
  啟: '66-Revelation'
};

export default audioBookFolders;